import { useAuthStore } from "@features/authentication/stores/authStore";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Auth route component that checks authentication status.
 * Redirects authenticated users to the discover page.
 */
export function AuthRoute() {
  const { status } = useAuthStore();

  // Show loading state while checking authentication
  if (status === "pending") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to discover page if already authenticated
  if (status === "authenticated") {
    return <Navigate to="/discover" replace />;
  }

  // Render auth content if not authenticated
  return <Outlet />;
}
